import { useTranslations } from '@vocab/react';
import { Stack, Text } from 'braid-design-system';
import React, { useContext } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { KeySellingPointList } from 'src/app/views/components/KeySellingPointList';
import { EditFlowDataContext } from 'src/app/views/context/cajaFlowData';
import { ContentLoader } from 'src/app/views/shared/ContentLoader';
import type AppState from 'src/types/appState';

import translations from './.vocab';

export const KeySellingPointsReadOnlyView = () => {
  const { keySellingPoints } = useSelector(
    (state: AppState) => ({
      keySellingPoints: [
        state.formData.keySellingPoint1,
        state.formData.keySellingPoint2,
        state.formData.keySellingPoint3,
      ],
    }),
    shallowEqual,
  );

  const { t } = useTranslations(translations);

  const { loading } = useContext(EditFlowDataContext);

  return (
    <Stack space="medium">
      <Text weight="strong">{t('key-selling-points-read-label')}</Text>
      <ContentLoader loading={loading} lines={['50%', '50%', '50%']}>
        {keySellingPoints.length > 0 ? (
          <KeySellingPointList items={keySellingPoints} />
        ) : null}
      </ContentLoader>
    </Stack>
  );
};
